import { ResponsiveLine } from '@nivo/line';

const errorsData = [
    {
      "id": "golang",
      "data": [
        { "x": "Jan", "y": 22 }, { "x": "Feb", "y": 25 }, { "x": "Mar", "y": 19 },
        { "x": "Apr", "y": 32 }, { "x": "May", "y": 28 }, { "x": "Jun", "y": 35 }
      ]
    },
    {
      "id": "script",
      "data": [
        { "x": "Jan", "y": 15 }, { "x": "Feb", "y": 18 }, { "x": "Mar", "y": 24 },
        { "x": "Apr", "y": 20 }, { "x": "May", "y": 26 }, { "x": "Jun", "y": 29 }
      ]
    }
  ];

export const ErrorsAreaChart = () => (
  <div style={{ height: '300px' }}>
    <ResponsiveLine
      areaOpacity={0.2}
      axisBottom={{
          legend: 'Month',
          legendOffset: 36,
          legendPosition: 'middle',
      }}
      axisLeft={{
          legend: 'Error Count',
          legendOffset: -40,
          legendPosition: 'middle',
      }}
      colors={{ scheme: 'pastel1' }}
      curve="catmullRom"
      data={errorsData}
      enableArea={true}
      legends={[
          {
              anchor: 'bottom-right',
              direction: 'column',
              translateX: 100,
              itemWidth: 80,
              itemHeight: 20,
              symbolSize: 12,
              symbolShape: 'circle',
          },
      ]}
      margin={{ top: 50, right: 110, bottom: 50, left: 60 }}
      pointBorderColor={{ from: 'serieColor' }}
      pointBorderWidth={2}
      pointSize={8}
      useMesh={true}
      xScale={{ type: 'point' }}
      yScale={{ type: 'linear', min: 0, max: 'auto' }}
    />
  </div>
);